module.exports = __webpack_public_path__ + "img/trawenagh_2.123f6d1c.webp";